<template>
    <div class="relative">
        <div v-if="loading2" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <div class="m-8 border border-gray-300 bg-gray-100 mb-0">
            <form @submit.prevent="update">
                <div class="m-8 mb-0 flex flex-wrap" @change="dirtyForm()" @keydown="dirtyForm">
                    <h1 class="text-green-600 text-lg text-left">Method of Funding</h1>
                    <div class="mb-6 w-full border-b-2"></div>
                    <label>Who will be paying your tuition fees and living costs?</label>
                    <select :value="applicationData.method_of_funding" @input="applicationData.method_of_funding = $event.target.value" class="pr-6 form-select bg-white" @change="fundingSelect($event)">
                        <option value="none" disabled selected>[Please select a method of funding]</option>
                        <option value="Applied">Applying for Sponsorship/Scholarship</option>
                        <option value="Awarded">Awarded Sponsorship/Scholarship</option>
                        <option value="Self">Self Funding</option>
                    </select>
                    <div v-if="showSelfFundSection" class="text-left">
                        <div class="mb-6 w-full border-b-2"></div>
                        <label class="w-full">If your sponsorship or scholarship application is unsuccessful, will you be able to self-fund your tuition fee and living costs?</label>
                        <div class="w-full">
                            <select v-model="applicationData.can_self_fund" class="form-select mb-4 w-full bg-white" @change="scholarshipName($event)">
                                <option value="none" disabled selected>[Please select a value]</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="!isScOrModule">
                        <div class="mb-1 w-full border-b-2"></div>
                        <h1 class="mt-8 text-green-600 text-lg text-left">LSHTM Scholarship</h1>
                        <div class="mb-6 w-full border-b-2"></div>
                        <div class="w-full flex">
                            <label class="text-left mb-4">Are you applying for a Scholarship advertised on the LSHTM website (Masters: <a class="text-decoration-underline" href="https://www.lshtm.ac.uk/study/fees-and-funding/funding-scholarships/masters-funding" target="_blank">Masters (Msc) funding and scholarships | Fee and funding | LSHTM</a>; Research Degree: <a class="text-decoration-underline" href="https://www.lshtm.ac.uk/study/fees-and-funding/funding-scholarships/research-degree-funding" target="_blank">Research degree funding and scholarships | Fees and funding | LSHTM</a>)?</label>
                            <div class="mb-4 ml-4 flex justify-start">
                                <div class="w-1/4 mr-3">
                                    <input :checked="applicationData.lshtm_scholarship===1" @input="applicationData.lshtm_scholarship = $event.target.value" type="radio" value="1" id="1" name="scholarship" @change="scholarshipSelect($event)">
                                    <label>Yes</label>
                                </div>
                                <div class="w-1/4 ml-3">
                                    <input :checked="applicationData.lshtm_scholarship===0" @input="applicationData.lshtm_scholarship = $event.target.value" type="radio" value="0" id="0" name="scholarship" @change="scholarshipSelect($event)">
                                    <label>No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="showScholarshipSection || applicationData.lshtm_scholarship===1" class="w-full flex">
                        <div class="text-left mb-4">
                            <p class="mb-4">When you submit your Admissions application for study, you will receive an email providing you with a link to access the Scholarships application portal.</p>
                            <p class="mb-4">To complete an application for funding, please refer to the instructions given in the specific Scholarship advertisement (see links above).</p>
                            <p class="mb-4">Please note you need to complete all the steps outlined in the Scholarship advert for your application to be considered.</p>
                            <p class="mb-4"><b>Please note:</b> The selection of funding shown in the list below are those administered by the LSHTM Scholarships team, other funding opportunities that are administered outside of LSHTM should be detailed in the Free Text box.</p>
                        </div>
                    </div>
                    <div v-if="showScholarshipSection || applicationData.lshtm_scholarship===1" class="w-full flex">
                        <label class="text-left mb-4">Please confirm you have read and understood the above:</label>
                        <div class="mb-4 ml-4 flex justify-start">
                            <div class="w-full-i mr-3">
                                <input v-model="applicationData.lshtm_scholarship_understood" type="checkbox" value="" id="1" name="scholarship_understood">
                                <label class="ml-4">I have read and understood the above.</label>
                            </div>
                        </div>
                    </div>
                    <div v-if="showScholarshipSection || applicationData.lshtm_scholarship===1" class="text-left w-full">
                        <label class="w-full">Please choose all the scholarships you are applying/applied to:</label>
                        <div class="w-full flex-column">
                            <div class="flex mb-2" v-for="(scholarship, index) in scholarships" :key="index">
                                <label class="w-1/2 ml-4">{{ scholarship }}</label>
                                <input  type="checkbox" :name="scholarship" :checked="this.applicationData.scholarship_name !== null && this.applicationData.scholarship_name.includes(scholarship)" class="ml-4 form-check-input" @change="scholarshipName($event)"/>
                            </div>

                        </div>

                    </div>
                    <text-input  v-if="showScholarshipSection || applicationData.lshtm_scholarship===1" v-model="applicationData.scholarship_name_other" :custom-class="this.customClass" class="w-full" label="Other" @update:modelValue="value = $event" />
                    <div v-if="showSponsorSection !== 'Self' && applicationData.method_of_funding !== 'Self'" class="w-full text-left">
                        <h1 class="my-4 text-green-600 text-lg text-left">Sponsor Details</h1>
                        <div class="mb-6 w-full border-b-2"></div>
                        <div v-if="showSponsorSection === 'Applied'">
                            Please enter your sponsor details below (Maximum of 5 sponsors).
                        </div>
                        <div v-if="showSponsorSection === 'Awarded'">
                            Please enter your sponsor details below. At least 1 sponsor must be entered (Maximum of 5 sponsors).
                        </div>
                        <div v-for="(item, index) in getSponsorData" :key="index" class="border border-gray-300 mb-8 flex p-6 bg-white">
                            <div class="w-1/4">
                                <h1 class="text-green-600 text-lg text-left">Sponsor {{ index+1 }}</h1>
                                <button type="button" class="mt-4 bg-red-600 hover:bg-red-700 text-white py-1 px-2 rounded text-sm" v-on:click="deleteSection(item.reference)">
                                    Remove this sponsor                                        
                                </button>
                            </div>
                            <div class="w-3/4">
                                <textarea-input :value="item.contact_details" @input="item.contact_details = $event.target.value" :customClass="this.customClass" class="mb-4" label="Sponsor name and address"/>
                                <text-input v-model="item.amount_of_award" @update:modelValue="value = $event" :customClass="this.customClass" label="Amount of award"/>
                                
                                <div v-if="serverErrors && serverErrors[index]" class="my-8 server-error">
                                    <div v-for="(value, key) in serverErrors[index]" :key="key">
                                        {{ value[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="scholarshipNameError" class="server-error m-8 w-auto">{{ scholarshipNameError }}</div>
                <div v-if="successMessage" class="success-message m-8 w-auto">{{ successMessage }}</div>
                
                <div v-if="!hideFundingBtn" class="lg:flex justify-end w-full pb-2 -mt-8">
                    <div class="relative w-auto lg:w-1/3 mt-8 mx-8">
                        <application-component-save-button :disabled="formDirty" class="w-full flex btn-green ml-auto md:inline-block text-center" type="submit">
                            Save Funding Details
                            <div class="lds-ring-container absolute top-10" v-if="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
                        </application-component-save-button>
                    </div>
                </div>

            </form>
            
            <ApplicationSponsorForm v-if="showForm" @cancelForm="cancelFormClick" :application-data="this.applicationData" />

            <button v-if="!showForm && getSponsorData.length < 5 && applicationData.method_of_funding !== 'Self'" type="button" class="text-sm flex items-center bg-green-600 hover:bg-green-700 text-white mx-8 -m-20 mb-8 py-2 px-4 rounded" v-on:click="addNewSection()">
                <icon name="plus-circle" class="w-6 h-6 mr-2"/> 
                Click to add new sponsor
            </button>
        </div>
    </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'
import TextareaInput from '@/shared/TextareaInput'
import ApplicationSponsorForm from '@/shared/forms/ApplicationSponsorForm'
import Icon from '@/shared/Icon'

export default {
  components: {
    ApplicationComponentSaveButton,
    TextInput,
    TextareaInput,
    Icon,
    ApplicationSponsorForm,
  },
  props:{
    sponsorData: Object,
    applicationData: Object,
    scholarships: Object,
  },
  data() {
    return {
        formDirty: false,
        loading: false,
        loading2: false,
        successMessage: '',
        scholarshipNameError:'',
        serverErrors:'',
        showSponsorSection: '',
        showScholarshipSection: false,
        customClass: 'w-full-i',
        showForm: false,
        showScholarshipOther: false,
        getSponsorData: this.sponsorData,
        hideFundingBtn: false,
        showSelfFundSection: false,
    }
  },
  computed: {
    isScOrModule() {
      return ['S','U'].includes(this.applicationData.programmeCode)
    },
  },
  mounted() {
    if (this.applicationData.method_of_funding === 'Applied') {
        this.showSponsorSection = 'Applied'
        this.showSelfFundSection = true;
    } else if (this.applicationData.method_of_funding === 'Awarded') {
        this.showSponsorSection = 'Awarded'
    }
    if (this.applicationData.scholarship_name === 'Other')
    {
        this.showScholarshipOther = true
    }

    if (this.isScOrModule) {
        this.applicationData.lshtm_scholarship = 0
    }
  },
  methods: {
    update() {
      this.loading = true;

      if (this.applicationData.lshtm_scholarship == 1 && !this.applicationData.lshtm_scholarship_understood){
          this.loading = false;
          this.scholarshipNameError = 'You must tick that you read and understood scholarship application instructions!'
          return
      }
      this.$store.dispatch('updateFundingDetails', {
        sponsorData: this.getSponsorData,
        applicationData: this.applicationData,
      })
      .then((response) => {
        this.loading = false
        this.successMessage = response.data
        this.scholarshipNameError = ''
        this.serverErrors = ''
        window.location.search += '&section=fundingDetailsShow';
      })
      .catch(error => {
        if (error.response.data.errors) {
            this.scholarshipNameError = ''
            this.serverErrors = Object.values(error.response.data.errors)
        } else {
            this.scholarshipNameError = error.response.data
            this.serverErrors = ''
        }
        this.loading = false
        this.successMessage = ''
      })
      this.formDirty = false
    },
    dirtyForm() {
        this.formDirty = true
        this.successMessage = ''
    },
    addNewSection(){
        this.hideFundingBtn = true
        this.showForm = true
    },
    cancelFormClick() {
        this.hideFundingBtn = false
        this.showForm = false
    },
    deleteSection(reference){
        if(this.getSponsorData.length === 1){
            alert('You need to have one active sponsor');
        } else {
        if(confirm("Are you sure you want to delete this item?")){
          this.loading2 = true,
          this.$store.dispatch('deleteSponsorItem', {
            sponsorItemRef: reference,
            applicationRef: this.$route.params.id,
          })
          .then((response) => {
            this.loading2 = false
            this.serverErrors = '',
            this.successMessage = response.data
            window.location.search += '&section=fundingDetailsShow';
          })
          .catch(error => {
            this.loading2 = false
            this.serverErrors = error.response.data
            this.successMessage = ''
          })
          this.formDirty = false
        }
      }
    },
    fundingSelect(event) {
        if (event.target.value === "Self"){
            var sponsorCount = this.sponsorData.length
            this.getSponsorData = this.sponsorData.splice(sponsorCount, 1)
        }
        this.showSelfFundSection = event.target.value === "Applied";
        this.showSponsorSection = event.target.value

        // pass value back to parent to show/hide the add sponsor button
        this.$emit('changeFunding', event.target.value)
    },
    scholarshipSelect(event) {
        if (event.target.value == 1){
            this.applicationData.scholarship_name = null
            this.applicationData.scholarship_name_other = null
            this.applicationData.lshtm_scholarship_understood = null
            this.showScholarshipOther = false
            this.showScholarshipSection = true
        } else {
            this.applicationData.scholarship_name = 0
            this.applicationData.scholarship_name_other = 0
            this.applicationData.lshtm_scholarship_understood = false
            this.showScholarshipOther = false
            this.showScholarshipSection = false
            this.scholarshipNameError = ''
        }
    },
    scholarshipName(event) {
        if (this.applicationData.scholarship_name === null) {
            this.applicationData.scholarship_name = [];
        }

        if (event.target.checked && !this.applicationData.scholarship_name.includes(event.target.name)) {
            this.applicationData.scholarship_name.push(event.target.name);
        }

        if (!event.target.checked && this.applicationData.scholarship_name.includes(event.target.name)) {
            this.applicationData.scholarship_name = this.applicationData.scholarship_name.filter(item => item !== event.target.name);
        }
    },
    
  }
}
</script>
<style scoped>
    .w-full-i{
        width: 100%!important;
        padding-right:0px;
    }
</style>